import { AfterViewInit, Component, ElementRef, Input, ViewChild, signal, SimpleChanges, OnChanges } from '@angular/core';
import tippy from 'tippy.js';

const defaultIconWidth = 31;
@Component({
  selector: 'libero-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false
})
export class ButtonComponent implements AfterViewInit, OnChanges {
  @Input() public btnClasses = '';
  @Input() public btnStyles = '';
  @Input() public label!: string;
  @Input() public svgIcon?: string;
  @Input() public svgClass?: Record<string, string | number>;
  @Input() public iconWidth: number = defaultIconWidth;
  @Input() public preloader?: boolean;
  @Input() public preloaderInverse = true;
  @Input() public smallSecondary = false;
  @Input() public disabledTooltipText: string | null = null;
  @Input() public buttonDisabled = false;
  // true -> disabledTooltipText contains only translation key; false -> disabledTooltipText contains the translated text already
  @Input() public tooltipUseTranslateKey = true;
  @Input() public uppercase = true;
  @Input() public active = false;

  @ViewChild('buttonContent') private buttonContent!: ElementRef;
  @ViewChild('tooltipContainerEl') private tooltipContainerEl!: ElementRef;

  public iconPath = signal<string | undefined>(undefined);
  public iconStyles = signal<Record<string, string | number> | null>(null);

  public get preloading(): boolean {
    return this.preloader ?? false;
  }

  public get disabledRecolorClass(): boolean {
    const disabledWithColorChange = [
      'instrumentsNotAllowedForDraftAccept',
      'newContractDisabled',
      'efektikaCannotChangeInstruments',
      'disabledOpfButton',
      'nothingForOpfTransferButton'
    ]
    return !!(this.disabledTooltipText && this.buttonDisabled && disabledWithColorChange.includes(this.disabledTooltipText));
  }

  public ngAfterViewInit(): void {
    if(this.disabledTooltipText && this.buttonContent) {
        tippy(this.buttonContent.nativeElement, {
        content: this.tooltipContainerEl.nativeElement.innerHTML,
        allowHTML: true,
        placement: 'auto',
        onShow: () => ((this.buttonDisabled && !!this.disabledTooltipText) || false) as false | void,
      });
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['svgIcon']) {
      this.iconPath.set('assets/icons/' + this.svgIcon + '.svg');
    }
    if(changes['iconWidth'] || changes['svgClass']) {
      const btnIconStyles = {...this.svgClass};
      if(this.iconWidth) {
        btnIconStyles['width.px'] = this.iconWidth;
      }
      this.iconStyles.set(btnIconStyles);
    }
  }

  public get classes(): string {
    return this.btnClasses;
  }

  public get styles(): string {
    return this.btnStyles;
  }
}
